type SalesChatContext =
  | 'hero'
  | 'pricing_free'
  | 'pricing_pro'
  | 'pricing_premium'
  | 'faq'
  | 'footer';

export function openSalesChat(context: SalesChatContext) {
  if (!window.$chatwoot) return;

  window.$chatwoot.toggle('open');
  window.$chatwoot.setCustomAttributes({
    source_section: context,
    visit_timestamp: new Date().toISOString(),
    page_url: window.location.href,
  });
  window.$chatwoot.setLabel(context);
}
